import React, {Component} from "react"

import {Card} from "semantic-ui-react"
import shop from "shop/shop"
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "style/ProductSlider.scss"

import ProductSlider from "components/Product/ProductSlider"
import productStore from "stores/productStore"
import _ from "lodash"

var instanceIndex = 0

class ProductSearchBasic extends Component {

	constructor( props ) {
		super( props )
		this.state = {
			products: [],
		}
		instanceIndex++
	}

	componentWillReceiveProps( props ) {
		if ( !this.props.static ) this.load( props )

	}

	componentDidMount() {
		this.load( this.props )
	}

	load( {cats, query, count, dir, sort, filters} ) {
		console.log( "LOAD", this.props )
		if ( cats.length > 0 ) this.loadFromCategories( {cats, query, count, dir, sort, filters} )
		if ( cats.length === 0 ) this.loadSearch( {query, count, dir, sort, filters} )
	}

	loadSearch( {query, count, dir, sort, filters} ) {
		this.lastQuery = {query}
		// shop.products.search( query, {
		//   count: this.props.count,
		//   page: 1
		// } )
		shop.products.query( {value: query, filter: filters, sort, count, dir} )
			.then( this.handleProducts )
	}

	loadFromCategories( {cats, query, count, dir, sort, filters} ) {
		console.log('search basic load from cats');
		this.lastQuery = {cats, query}
		shop.products.fromCategory( cats, {
				query,
				sort,
				count,
				dir
			},
			filters
			)
			.then( res => {
				let {products} = res
				if(!products) return res
				if ( products && products.length === 0 && this.props.cats && this.props.cats[0] ) {
					let id = cats
					let category = _.first( _.filter( [...shop.categoriesById.entries()], (( [cat_id, cat] ) => cat.map_id === id) ) )
					if ( category ) category = category[1]

					if ( products.length === 0 ) {
						// get products from all child categories
						const mapChildren = cat => {
							if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
							return cat.map_id
						}
						const ids = _.flatten( category && category.children.map( mapChildren ) )
						if ( ids.length > 0 ) {
							return productStore.fromCategory( ids, {query, sort, dir, count,}, filters )
						}
					}
				}
				return res
			} )
			.then( this.handleProducts )
	}

	handleProducts = ( response ) => {
		let {products} = response
		if ( !products ) return
		this.setState( {products} )

		this.props.onLoad && this.props.onLoad({products})
	}

	render() {
		let Child = this.props.repeat
		let {title} = this.props
		const {products} = this.state
		if ( products.length === 0 ) {
			return <div><br/>Keine Produkte in dieser Kollektion</div>
		}

		const {displayMode = "grid"} = this.props

		let cards = <div>Layout {displayMode} nicht definiert</div>

		switch ( displayMode ) {
			case "cards":
				cards = <Card.Group itemsPerRow="4">
					{products.map( product => <Child key={product.map_id}
													 product={product} /> )
					}
				</Card.Group>
				break;

			case "grid":
				cards = <Card.Group itemsPerRow="4">
					{products.map( product => <Child key={product.map_id}
													 product={product} /> )
					}
				</Card.Group>
				break;

			case "list":
				cards = <Card.Group itemsPerRow="4">
					{products.map( product => <Child key={product.map_id}
													 product={product} /> )
					}
				</Card.Group>
				break;

			case "slider":
				cards = <div>
					<ProductSlider Card={Child} products={products} />
				</div>
				break;

			case "custom":
				cards = <React.Fragment>
					{products.map( product => <Child key={product.map_id}
													 product={product} /> )
					}
				</React.Fragment>
				break;
		}

		return (
			<div key={this.props.key}>
				{(title) ? <div className="row-title"><h2>{title}</h2></div> : null}
				{cards}
			</div>
		)
	}
}

ProductSearchBasic.defaultProps = {
	count: 4, start: 0, query: "%%", cats: []
}


export default ProductSearchBasic



// WEBPACK FOOTER //
// ./src/components/Product/ProductSearchBasic.js